<script setup>
import { ref, onMounted, reactive, computed, watch } from 'vue'
import { gApp } from '../Globals.js'

const props = defineProps({
  title: {
    default: "",
  },
  styles: {
    default: {},
  },
  inline: {
    default: false,
  },
  pagePath: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(['onOpen'])

let isOpen = ref(false);

function getIconClasses() {
  return {'bi-chevron-down': true};
}

function toggleOpen() {
  if (isOpen.value) {
    isOpen.value = false;
  } else {
    isOpen.value = true;
    emit('onOpen');
  }
}

let sectionHasErrors = computed(() => {
  if (!props.pagePath) {
    return false;
  }
  let projectErrors = gApp.proj().getProjectErrors();
  return projectErrors.checkPageHasErrors(props.pagePath);
});

</script>

<template>
  <div class="SimpleCollapse CollapseDiv" :class="styles">
    <button class="CollapseBtn"
      @click="toggleOpen" :class="{IsOpen: isOpen, Inline: inline, HasErrors: sectionHasErrors}"
    >
      {{ title }}<i class="icon" :class="getIconClasses()"></i>
    </button>
    <div v-if="isOpen" class="Content" :class="{Inline: inline}">
      <slot>Default body</slot>
    </div>
  </div>
</template>

<style scoped>
.CollapseDiv {
  max-width: 1000px;
}

.CollapseBtn {
  background-color: white;
  width: 100%;
  border: 1px solid var(--pc-light);
  border-radius: var(--br-s);
  padding: 12px 16px;
  text-align: left;
  font-size: var(--f-m);
  position: relative;
  transition: all 0.2s ease;
  color: var(--pc-darkest);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  user-select: none;
}

.CollapseBtn.Inline {
  border-color: var(--pc-med2);
  background-color: var(--pc-lightest);
  box-shadow: none;
}

.CollapseBtn:hover {
  background-color: var(--pc-lightest);
  border-color: var(--pc);
}

.CollapseBtn.Inline:hover {
  background-color: var(--pc-light);
}

.CollapseDiv.Emphasis .CollapseBtn {
  background-color: var(--pc-lightest);
  border-color: var(--pc);
  font-weight: 500;
}

.CollapseDiv.Emphasis .CollapseBtn:hover {
  background-color: var(--pc-light);
}

.CollapseBtn.IsOpen {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: transparent;
  background-color: var(--pc-lightest);
}

.Content {
  padding: var(--space-s);
  background-color: white;
  border: 1px solid var(--pc-light);
  border-top: none;
  border-bottom-left-radius: var(--br-s);
  border-bottom-right-radius: var(--br-s);
}

.Content.Inline {
  border-color: var(--pc-med2);
}

.icon {
  float: right;
  color: var(--pc);
  transition: transform 0.2s ease;
}

.CollapseBtn.IsOpen .icon {
  transform: rotate(180deg);
}

.CollapseBtn.HasErrors {
  position: relative;
  border-left: 4px solid var(--delete-red);
  padding-left: 30px;
}

.CollapseBtn.HasErrors::before {
  content: '!';
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background-color: var(--delete-red);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  box-shadow: 0 0 8px rgba(231, 4, 15, 0.5);
}

.CollapseBtn.HasErrors:hover {
  background-color: rgba(231, 4, 15, 0.1);
}
</style>
